import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import i18n from '@/i18n';
import {
  courseAppearanceService,
  type CourseMenuItem,
} from '@/services/course-appearance.service';
import { appearanceKeys } from './queryKeys';

/** Delete a per-course menu item optimistically. */
export function useDeleteCourseMenuItem(productId: string) {
  const qc = useQueryClient();
  const key = appearanceKeys.menuItems(productId);

  return useMutation({
    mutationFn: (itemId: string) =>
      courseAppearanceService.deleteMenuItem(productId, itemId),
    onMutate: async (itemId) => {
      await qc.cancelQueries({ queryKey: key });
      const prev = qc.getQueryData<CourseMenuItem[]>(key);
      if (prev) {
        qc.setQueryData<CourseMenuItem[]>(
          key,
          prev.filter((i) => i.id !== itemId),
        );
      }
      return { prev };
    },
    onError: (_e, _v, ctx) => {
      if (ctx?.prev) qc.setQueryData(key, ctx.prev);
      toast.error(i18n.t('adminAppearance:toasts.deleteMenuItemError'));
    },
    onSettled: () => qc.invalidateQueries({ queryKey: key }),
  });
}
